// tslint:disable
/**
 * Import Export Api Manager (V2)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Info } from './info';

/**
 * 
 * @export
 * @interface Import
 */
export interface Import {
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    type: string;
    /**
     * 
     * @type {Info}
     * @memberof Import
     */
    typeInfo: Info;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    status: ImportStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Import
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Import
     */
    finishedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Import
     */
    createdAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum ImportStatusEnum {
    Waiting = 'waiting',
    Started = 'started',
    Success = 'success',
    Fail = 'fail'
}



